// Ensure process polyfill is included for environments where it's undefined
import process from 'process';

if (typeof global.process === "undefined") {
  global.process = process;
}

// Define global.$o if it's undefined
if (typeof global.$o === "undefined") {
  global.$o = {
    // Random number generator
    rnd: Math.random, 

    // Function to register export types
    registerExport: (config, exportFunction) => {
      if (!global.$o.exports) {
        global.$o.exports = [];
      }
      global.$o.exports.push({ config, exportFunction });
    },

    // Retrieve all registered exports
    getRegisteredExports: () => {
      return global.$o.exports || [];
    },
  };
}
